import CodeBlock from "./../code-block";

//this model represents a primitive block
export default CodeBlock.extend({});
